export const negativeResponse = [
  { key: "estuvoEnUci", id: "acdf7743-5121-44f1-b457-29b0b03b1b12" },
  { key: "tieneEnfermedadCorazon", id: "9ecaaaf8-c428-4a39-8a5a-d0b9b98326c7" },
  { key: "tieneArritmiaCardiaca", id: "062b500b-d3ad-45ea-8eb8-0c4400a8a1c6" },
  { key: "tieneEnfermedadValvularCardiaca", id: "15b1009f-c37f-49b0-bc93-54005fe0f320" },
  { key: "tienePresionAlta", id: "4f2d4c65-ea3d-4d3b-9ec5-62f3e4a1bfa1" },
  { key: "tieneDolorPechoAlEsfuerzo", id: "5e1ff1e4-4864-43d4-b7b4-717ff399b18f" },
  { key: "tieneEnfermedadPulmones", id: "be5f634b-60c1-44b3-92ed-d00a9b342f32" },
  { key: "sufreApnea", id: "fd0798d3-85d8-484d-a036-d4e51c0da1ff" },
  { key: "usaCPAP", id: "c7a9b063-2a70-4e5b-bf65-621f773d3547" },
  { key: "tieneEnfermedadCerebroVascular", id: "3831b543-07a6-4c2d-9277-28b2a2d3a106" },
  { key: "tieneDiabetes", id: "098cb544-1d4b-48f0-bc2d-2a030cb4e68f" },
  { key: "usaInsulina", id: "51b72cd9-7e77-4f45-8b13-d110b7fc6d08" },
  { key: "tieneEnfermedadRinones", id: "12f7e41a-99f9-48b6-b833-86e4045d2355" },
  { key: "tieneEnfermedadGraveHigado", id: "4bb33f5d-4061-4cc7-bd9e-1be1cfb5f7be" },
  { key: "sufreReflujoGastritis", id: "f1c5d17d-4b69-46fe-bc8a-3f45ed3fd88c" },
  { key: "tieneProblemasTiroides", id: "64cf92f3-4fcb-455d-b2f2-8f3c9a26a14d" },
  { key: "sangraFacilmente", id: "d1ac52bb-bd93-46f9-b8f5-b2131771efb5" },
  { key: "haRecibidoTransfusiones", id: "48de2132-7170-4646-880f-1c23d0b6d857" },
  { key: "tieneTrombosFlebitis", id: "6325771b-01c3-46ca-b0a9-3a78a58198f5" },
  { key: "viajoUltimosDosDias", id: "edab6182-b5e9-4795-bbfb-b14a03f2402d" },
  { key: "tuvoGripaReciente", id: "0d1a223f-cff7-4297-b672-43fa84beae0f" },
  { key: "sufreDolorEspalda", id: "3c0d1f79-d7a6-467f-9bc5-dbc4eec6a380" },
  { key: "tieneLimitacionMovimiento", id: "cc6c1e91-b498-40b1-94d9-e5b3e0ec3d9e" },
  { key: "sufreConvulsiones", id: "19cf4504-704b-48e9-a3f9-f080973604fa" },
  { key: "tieneOtraEnfermedad", id: "adffb779-b800-4ab0-b536-5f08ab442f70" },
  { key: "estaEmbarazada", id: "65ab4b2b-741f-47c8-9f59-b72f9e3321f8" },
  { key: "alergicoMaterial", id: "b4c9b381-3c9a-4136-8a0c-c9b7b4384e6a" },
  { key: "alergicoMedicamento", id: "94efdfd8-68a5-4299-bc25-c42a819e29bc" },
  { key: "tomaMedicamentoRegular", id: "ad32cbb1-021f-4f99-8410-35df7f917c63" },
  { key: "tomaHomeopaticos", id: "37a4a330-9a35-4c52-a86c-7ed7f0f92c25" },
  { key: "bebeAlcohol", id: "9ac5a5ff-14f9-4217-8770-c7f1572d7005" },
  { key: "fuma", id: "c292c65e-7e9e-4716-8a42-345be8d2b73a" },
  { key: "consumeDrogasPsicoactivas", id: "4435f7d5-ea7f-4e9f-b021-3e8b2d3a4b9f" },
  { key: "usaTratamientoFacial", id: "f14eb54c-7175-470b-bcb5-90b99e7a607d" },
  { key: "usaLentesContacto", id: "5b8d0a9a-4dfd-44a4-b5c1-9a5a37acb35f" },
  { key: "tieneDientesArtificiales", id: "0d2b6d8b-0be5-47a9-a9b4-b800fcae1a01" },
  { key: "haSidoOperado", id: "ed2b35f8-e735-4b7e-9a3b-78c54fbd14ef" },
  { key: "sienteEstres", id: "0397b6d9-93f1-4019-b25e-8c3141ed26c1" },
  { key: "estudioPSA", id: "3efc0630-bcb5-43b4-bd9f-0225b693e9f5" },
  { key: "tieneAlergias", id: "fc8cd907-ed7d-11f0-bea3-066d180a3717"},
  { key: "bajopesoExtremo", id: "f26c9470-2e49-418a-a3c6-b330c80ff1c9"},
  { key: "bajaEnergia", id: "a1601a98-1148-49a0-ad74-75c9f544521a"},
  { key: "tieneAsma", id: "a829277a-b224-4c44-9c4f-5f20486955c9"},
  { key: "tieneVIH", id: "8d17169c-5cb5-4fbf-b3b7-ae2ffeaa5b28"}
];